import db from "../db/database";
import { markForDelete, markForSync } from "./syncService";
import { hayCajaAbierta, setAperturaActiva, clearAperturaActiva } from "./cajaEstadoService";

// Servicio para manejar las operaciones relacionadas con apertura de caja

// Agregar una nueva apertura de caja a la base de datos
export const addAperturaDeCaja = async (aperturaDeCaja) => {
    try {
        // Verificar si ya hay una caja abierta
        const cajaAbierta = await hayCajaAbierta();
        if (cajaAbierta) {
            throw new Error("Ya existe una caja abierta. Debe cerrar la caja actual antes de abrir una nueva.");
        }

        // Obtener la hora actual en formato HH:MM
        const horaActual = new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });

        // Agregar la apertura de caja a la base de datos
        const id = await db.aperturaDeCaja.add({
            No: aperturaDeCaja.No || null, // Añadir campo No para Business Central
            Cajero: aperturaDeCaja.Cajero,
            FechaDeApertura: aperturaDeCaja.FechaDeApertura,
            HoraDeApertura: aperturaDeCaja.HoraDeApertura || horaActual, // Usar la hora proporcionada o la actual
            ImporteDeApertura: aperturaDeCaja.ImporteDeApertura,
            Estado: aperturaDeCaja.Estado || "Abierto", // Por defecto, el estado es "Abierto"
            Turno: aperturaDeCaja.Turno,
            Caja: aperturaDeCaja.Caja,
            TPV: aperturaDeCaja.TPV,
            createdAt: new Date(),
            pendingSync: 1, // Marcar como pendiente de sincronización
            lastModified: new Date(),
            deleted: false,
        });

        const nuevaApertura = {
            id,
            ...aperturaDeCaja,
            HoraDeApertura: aperturaDeCaja.HoraDeApertura || horaActual
        };

        // Si el estado es "Abierto", establecer como caja activa
        if (nuevaApertura.Estado === "Abierto") {
            await setAperturaActiva(nuevaApertura);
        }

        return nuevaApertura;
    } catch (error) {
        console.error("Error al agregar apertura de caja:", error);
        throw error;
    }
};

// Obtener todas las aperturas de caja
export const getAllAperturasDeCaja = async () => {
    try {
        // Obtener solo aperturas no marcadas como eliminadas
        const aperturasDeCaja = await db.aperturaDeCaja
            .filter((apertura) => !apertura.deleted)
            .toArray();
        return aperturasDeCaja;
    } catch (error) {
        console.error("Error al obtener aperturas de caja:", error);
        throw error;
    }
};

// Obtener una apertura de caja por ID local
export const getAperturaDeCajaById = async (id) => {
    try {
        const aperturaDeCaja = await db.aperturaDeCaja.get(id);
        if (!aperturaDeCaja || aperturaDeCaja.deleted) {
            throw new Error("Apertura de caja no encontrada");
        }
        return aperturaDeCaja;
    } catch (error) {
        console.error(`Error al obtener apertura de caja con ID ${id}:`, error);
        throw error;
    }
};

// Obtener una apertura de caja por No de Business Central
export const getAperturaDeCajaByNo = async (no) => {
    try {
        const aperturaDeCaja = await db.aperturaDeCaja
            .where("No")
            .equals(no)
            .and((apertura) => !apertura.deleted)
            .first();

        if (!aperturaDeCaja) {
            throw new Error("Apertura de caja no encontrada");
        }
        return aperturaDeCaja;
    } catch (error) {
        console.error(`Error al obtener apertura de caja con No ${no}:`, error);
        throw error;
    }
};

// Actualizar una apertura de caja existente
export const updateAperturaDeCaja = async (id, aperturaDeCajaData) => {
    try {
        const aperturaDeCaja = await db.aperturaDeCaja.get(id);
        if (!aperturaDeCaja || aperturaDeCaja.deleted) {
            throw new Error("Apertura de caja no encontrada");
        }

        // Guardar el estado anterior para comparar
        const estadoAnterior = aperturaDeCaja.Estado;

        // Actualizar la apertura de caja
        await db.aperturaDeCaja.update(id, {
            ...aperturaDeCajaData,
            lastModified: new Date(),
        });

        // Marcar como pendiente de sincronización
        await markForSync("aperturaDeCaja", id);

        const aperturaActualizada = await getAperturaDeCajaById(id);

        // Si el estado cambió de "Abierto" a otro, limpiar la caja activa
        if (estadoAnterior === "Abierto" && aperturaActualizada.Estado !== "Abierto") {
            await clearAperturaActiva();
        }
        // Si el estado cambió a "Abierto", establecer como caja activa
        else if (estadoAnterior !== "Abierto" && aperturaActualizada.Estado === "Abierto") {
            // Verificar si ya hay otra caja abierta
            const cajaAbierta = await hayCajaAbierta();
            if (cajaAbierta) {
                // Revertir el cambio de estado
                await db.aperturaDeCaja.update(id, {
                    Estado: estadoAnterior,
                    lastModified: new Date(),
                });
                throw new Error("Ya existe una caja abierta. Debe cerrar la caja actual antes de abrir una nueva.");
            }
            await setAperturaActiva(aperturaActualizada);
        }

        return aperturaActualizada;
    } catch (error) {
        console.error(`Error al actualizar apertura de caja con ID ${id}:`, error);
        throw error;
    }
};

// Eliminar una apertura de caja
export const deleteAperturaDeCaja = async (id) => {
    try {
        const aperturaDeCaja = await db.aperturaDeCaja.get(id);
        if (!aperturaDeCaja) {
            throw new Error("Apertura de caja no encontrada");
        }

        // Si es la caja activa, impedir su eliminación
        if (aperturaDeCaja.Estado === "Abierto") {
            throw new Error("No se puede eliminar una apertura de caja que está actualmente abierta. Cierre la caja primero.");
        }

        // Marcar como eliminado y pendiente de sincronización
        await markForDelete("aperturaDeCaja", id);

        return true;
    } catch (error) {
        console.error(`Error al eliminar apertura de caja con ID ${id}:`, error);
        throw error;
    }
}; 


export const getAperturaCaja = async (date, cajero, turn, tpv) => {
     const aperturaDeCaja = await db.aperturaDeCaja.where("FechaDeApertura")
		.between(date, date, true, true)
		.toArray();
    
        console.log(tpv);
     	return aperturaDeCaja.filter(x =>
		(!turn || x.Turno === turn) &&
		(!tpv || x.Caja === tpv) &&
        (!cajero || x.Cajero === cajero)
	);

     
}